<template>
  <header v-if="isLoggedIn" class="header" :class="{ 'is-notice': isNotice || isNoticeInquiry }">
    <a :href="hrefLink" class="nav-logo"></a>

    <a :href="methodLink" class="method-logo" target="_blank"></a>

    <Slide width="250" right :closeOnNavigation="true" noOverlay>
      <div class="menu-text">Menu</div>
      <router-link :to="{ name: 'notice'}"><span class="navigation"><template v-if="isNotice"><span :style="{ color : isNotice ? 'red' : 'black' }"><i class="fas fa-bell"></i>&nbsp;&nbsp;{{ $t('notice.title') }}</span></template><template v-else>{{ $t('notice.title') }}</template> <i class="fas fa-chevron-right"></i></span></router-link>
      <router-link :to="{ name: 'profile'}"><span class="navigation">{{ $t('profile.title') }} <i class="fas fa-chevron-right"></i></span></router-link>
      <router-link :to="{ name: 'inquiry'}"><span class="navigation"><template v-if="isNoticeInquiry"><span :style="{ color : isNoticeInquiry ? 'red' : 'black' }"><i class="fas fa-bell"></i>&nbsp;&nbsp;{{ $t('inquiry.title') }}</span></template><template v-else>{{ $t('inquiry.title') }}</template> <i class="fas fa-chevron-right"></i></span></router-link>

      <a @click.prevent="logout" class="router-link-active"><span class="navigation navigation-logout">{{ $t('logout.title') }} <i class="fas fa-chevron-right"></i></span></a>

    </Slide>
    <logoutmodal v-show="logout_modal" @close="close"></logoutmodal>
  </header>
  
  <header v-else class="header">
    <a href="/" class="nav-logo"></a>
  </header>  
</template>

<script>
  import {appName, api} from '../../config';
  import {mapGetters} from 'vuex';

  import { Slide } from 'vue-burger-menu'
  
  import LogoutModal from '../login/LogoutModal.vue'

  export default {
    data() {
      return {
        appName: appName,
        logout_modal: false,
        currentYear: (new Date).getFullYear()
      }
    },
    components: {
      Slide,
      'logoutmodal': LogoutModal,
    },
    created() {
      this.logout_modal = false
    },
    
    computed: {
      isNotice() {
        if (this.$route.name == 'login') {
          return false
        } else {
          let unreadList = this.$store.getters.unreadnews.filter(item => {
            return ('type' in item.data && item.data.type == 'news')
          })
          
          return unreadList.length > 0 ? true : false
        }
      },
      isNoticeInquiry() {
        if (this.$route.name == 'login') {
          return false
        } else {
          let unreadList = this.$store.getters.unreadnews.filter(item => {
            return ('type' in item.data && item.data.type == 'inquiry')
          })
          return unreadList.length > 0 ? true : false
        }
      },
      isLoggedIn() {
        const authUser = this.$store.getters.getAuthUser;
        if(authUser) {
          return true;
        } else {
          return false;
        }
      },
      hrefLink() {
        if (this.$route.name == 'lesson') {
          return '/apps'
        } else {
          return '/apps'
        }
      },
      methodLink() {
        return window.global.jsl_method_url + '/apps'
      }
    },

    methods: {
      logout() {
        this.logout_modal = true;
      },
      close() {
        this.logout_modal = false;
      }
    },
  }
</script>
<style lang="scss">


</style>
